import axios from 'axios';
import * as endpoints from '../endpoints';
import { constants } from '../constants';

const baseUrl = constants.baseURL;

export const uploadAttachments = async (formData) => {
  return axios({
    method: 'post',
    url: endpoints.Attachment.UPLOAD,
    baseURL: baseUrl,
    data: formData,
  }).then((response) => response.data.result);
};

export const deleteAttachment = async (id) => {
  return axios({
    method: 'delete',
    url: `${endpoints.Attachment.BASE}/${id}`,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};
